/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🎨 STYLES */
import { NavigationContainer, Link } from "./styles";

const Breadcrumb = ({ flow }) => {

    const { t } = useTranslation();

    return(
        <NavigationContainer>
            {flow?.map((item, index) =>
                <li key={index}>
                    {item.page ? (
                        <Link to={item.page}>{t(`navigation-flow.${item.text}`)}</Link>
                    ) : (
                        <span>{t(`navigation-flow.${item.text}`)}</span>
                    )}
                    {index < flow.length - 1 && (<span className='symbol'>{'>'}</span>)}
                </li>
            )}
        </NavigationContainer>
    );
}

export default Breadcrumb;